import 'zone.js/plugins/zone-error'; // Included with Angular CLI.import { Config } from '../app/configs/index.config';
import { environment as env } from 'projects/evolutics-shared-lib/src/environments/environment';
env.useUserMenu = false;
env.debug = true;
env.authenticate = true;
export const salesEnvironment = env;
salesEnvironment.appName = 'Evolutics Sales Portal';
salesEnvironment.versionNo = '1.0.1';
